module.exports = __webpack_public_path__ + "static/nasa-7386134486c9c70f595a54a0a6ef82b1.jpg";